(() => {
  if (window.forthiqTaxPopupReady) return;
  window.forthiqTaxPopupReady = true;

  let opener = null;
  let lockedPage = null;
  let dismissTimer = null;
  const mobileQuery = window.matchMedia('(max-width: 640px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const lockPage = () => {
    if (!mobileQuery.matches || lockedPage) return;

    const body = document.body;
    const root = document.documentElement;
    lockedPage = {
      scrollY: window.scrollY,
      body: {
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
        overflow: body.style.overflow
      },
      rootOverflow: root.style.overflow
    };

    body.style.position = 'fixed';
    body.style.top = `-${lockedPage.scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    root.style.overflow = 'hidden';
  };

  const unlockPage = () => {
    if (!lockedPage) return;

    const body = document.body;
    const root = document.documentElement;
    const page = lockedPage;
    lockedPage = null;

    Object.assign(body.style, page.body);
    root.style.overflow = page.rootOverflow;
    window.scrollTo(0, page.scrollY);
  };

  const resetSwipe = (dialog, animate = false) => {
    dialog.classList.remove('is-swiping', 'is-dismissing');
    if (animate) dialog.classList.add('is-swipe-resetting');
    dialog.style.removeProperty('--forthiq-tax-swipe-opacity');
    dialog.style.removeProperty('--forthiq-tax-swipe-y');
    dialog.style.removeProperty('--forthiq-tax-dismiss-y');

    if (animate) {
      window.setTimeout(() => dialog.classList.remove('is-swipe-resetting'), 160);
    } else {
      dialog.classList.remove('is-swipe-resetting');
    }
  };

  const bindDialog = (dialog) => {
    if (dialog.dataset.forthiqTaxBound) return;
    dialog.dataset.forthiqTaxBound = 'true';

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      dialog.close();
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let swipeDistance = 0;
    let isVerticalSwipe = false;

    dialog.addEventListener('touchstart', (event) => {
      if (!mobileQuery.matches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      swipeDistance = 0;
      isVerticalSwipe = false;
      resetSwipe(dialog);
    }, { passive: true });

    dialog.addEventListener('touchmove', (event) => {
      if (!mobileQuery.matches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      if (!isVerticalSwipe && Math.abs(deltaY) < 6) return;
      if (!isVerticalSwipe && Math.abs(deltaY) <= Math.abs(deltaX)) return;

      isVerticalSwipe = true;
      swipeDistance = deltaY;
      event.preventDefault();

      const progress = Math.min(Math.abs(deltaY) / 140, 1);
      const movement = Math.max(-18, Math.min(18, deltaY * .16));
      dialog.classList.add('is-swiping');
      dialog.style.setProperty('--forthiq-tax-swipe-opacity', String(1 - progress * .82));
      dialog.style.setProperty('--forthiq-tax-swipe-y', `${movement}px`);
    }, { passive: false });

    const finishSwipe = () => {
      if (!isVerticalSwipe) return;
      isVerticalSwipe = false;

      if (Math.abs(swipeDistance) < 32) {
        resetSwipe(dialog, true);
        return;
      }

      const direction = swipeDistance < 0 ? -1 : 1;
      dialog.style.setProperty('--forthiq-tax-dismiss-y', `${direction * 22}px`);
      dialog.classList.remove('is-swiping');
      dialog.classList.add('is-dismissing');

      if (reducedMotionQuery.matches) {
        dialog.close();
        return;
      }

      dismissTimer = window.setTimeout(() => dialog.close(), 180);
    };

    dialog.addEventListener('touchend', finishSwipe);
    dialog.addEventListener('touchcancel', () => {
      isVerticalSwipe = false;
      resetSwipe(dialog, true);
    });

    dialog.addEventListener('close', () => {
      if (dismissTimer) window.clearTimeout(dismissTimer);
      dismissTimer = null;
      resetSwipe(dialog);
      unlockPage();
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
      opener = null;
    });
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-forthiq-tax-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.forthiqTaxOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      opener = openButton;
      bindDialog(dialog);
      dialog.showModal();
      lockPage();
      return;
    }

    const closeButton = event.target.closest('[data-forthiq-tax-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
  });
})();
